<rk-modal-wrapper
  (submitted)="submit()"
  (cancelled)="onCancel()"
  (closed)="onCancel()"
  [title]="'MODAL.DELETE_PROGRAM.TITLE' | translate"
  [submitText]="'MODAL.DELETE_PROGRAM.DELETE' | translate"
  [loading]="isSaving$ | async"
  [hideCancelOnLoading]="true"
>
  <div
    [innerHTML]="'MODAL.DELETE_PROGRAM.CONFIRM' | translate: { name: program.name }"
  ></div>
</rk-modal-wrapper>
